export const ScoreTypeConstants = {
  COURSE_PRACTICAL_EVALUATION: 'bc611c36-2592-4df5-b908-160a41009341',
  COMPETITION: 'e5ad4e36-52b4-4246-8a26-6280a983ac18',
  IN_HOUSE: '48584102-cc13-4382-b717-f4264bcb4ae7',
};
